<div class="checkbox-wrapper mb-2" [ngClass]="options?.containerClass">
  <p-checkbox
    [binary]="true"
    [label]="options.label | translate"
    [formControlName]="options.formControlName"
    [value]="options.value ?? true"
    (onChange)="onChange($event)"
  >
  </p-checkbox>

  <app-field-errors [errors]="errors"></app-field-errors>
</div>
